import type { GeoJSONFeature } from "maplibre-gl";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface EasementsTableProps {
  intersectingEasements: GeoJSONFeature[];
}

export const EasementsTable = (props: EasementsTableProps) => {
  const firstGeometryType = props.intersectingEasements[0].geometry.type;

  return (
    <div className="w-full">
      <h6 className="text-base font-semibold">Easements on Parcel</h6>
      <div className="max-h-50 overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-bold">Contributer ID</TableHead>
              <TableHead className="font-bold">State</TableHead>
              <TableHead className="font-bold">Contributor Type</TableHead>
              {firstGeometryType === "LineString" && (
                <TableHead className="font-bold">Length</TableHead>
              )}
              {firstGeometryType === "Polygon" && (
                <TableHead className="font-bold">Area</TableHead>
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {props.intersectingEasements.map((easement) => {
              if (!easement.properties) return null;
              const key =
                easement.geometry.type === "LineString"
                  ? easement.properties.easement_line_pid
                  : easement.properties.easement_polygon_pid;
              return (
                <TableRow key={key} className="last:border-0">
                  <TableCell className="py-1">
                    {easement.properties.contributor_id}
                  </TableCell>
                  <TableCell className="py-1">
                    {easement.properties.state}
                  </TableCell>
                  <TableCell className="py-1">
                    {easement.properties.contributor_type}
                  </TableCell>
                  {easement.geometry.type === "LineString" && (
                    <TableCell className="py-1">{`${easement.properties.length} m`}</TableCell>
                  )}
                  {easement.geometry.type === "Polygon" && (
                    <TableCell className="py-1">{`${easement.properties.area} m²`}</TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
